export const RoutesPath = {
    home: '/',

    termsOfUse: '/terms-of-use',
    privacyPolicy: '/privacy-policy',
    privacyPolicyProfilePages: '/privacy-policy/profile/*',
    privacyPolicyProfile: '/privacy-policy/profile',
    aboutUs: '/about-us',

    login: '/login',
    logout: '/logout',

    panel: '/panel',
    ostPanel: '/panel/*',

    createLocation: '/panel/locations/add-new-location',
    locations: '/panel/locations',
    ostLocations: '/panel/locations/*',
    
    createMarker: '/panel/markers/add-new-marker',
    markers: '/panel/markers',
    ostMarkers: '/panel/markers/*',

    createSection: '/panel/sections/add-new-section',
    sections: '/panel/sections',
    ostSections: '/panel/sections/*',

    createChapter: '/panel/chapters/add-new-chapter',
    chapters: '/panel/chapters',
    ostChapters: '/panel/chapters/*',

    createCategory: '/panel/categories/add-new-category',
    categories: '/panel/categories',
    ostCategories: '/panel/categories/*',

    createRankAboniment: '/panel/rank-aboniment/add-new-rank-aboniment',
    rankAboniment: '/panel/rank-aboniment',
    ostRankAboniment: '/panel/rank-aboniment/*',
    rankAbonimentSet: '/panel/rank-aboniment/settings/*',

    notifications: '/push-notifications',
    ostNotifications: '/push-notifications/*',

    createAdmin: '/admins/create-new-admin',
    admins: '/admins',
    ostAdmins: '/admins/*',
    admin: '/admins/id/:adminId/*',
    adminSet: '/admins/id/:adminId/settings/*',

    createLezzetDelivery: '/lezzet-deliveries/create-new-lezzet-delivery',
    lezzetDeliverys: '/lezzet-deliveries',
    ostLezzetDeliverys: '/lezzet-deliveries/*',
    lezzetDelivery: '/lezzet-deliveries/id/:lezzetDeliveryId/*',
    lezzetDeliverySet: '/lezzet-deliveries/id/:lezzetDeliveryId/settings/*',

    createCourier: '/couriers/create-new-courier',
    couriers: '/couriers',
    ostCouriers: '/couriers/*',
    courier: '/couriers/id/:courierId/*',
    courierSet: '/couriers/id/:courierId/settings/*',
    courierCarts: '/couriers/id/:courierId/carts/*',
    courierPushNotifications: '/couriers/id/:courierId/push-notifications/*',

    profiles: '/profiles',
    profile: '/profiles/id/:profileId/*',
    profileSet: '/profiles/id/:profileId/settings/*',
    profileCarts: '/profiles/id/:profileId/carts/*',
    profilePushNotifications: '/profiles/id/:profileId/push-notifications/*',

    carts: '/carts',
    ostCarts: '/carts/*',
    cart: '/carts/id/:cartId/*',
    cartSet: '/carts/id/:cartId/settings/*',

    createStore: '/stores/open-new-store',
    stores: '/stores',
    ostStores: '/stores/*',
    store: '/stores/id/:storeId/*',
    storeSet: '/stores/id/:storeId/settings/*',
    storeCarts: '/stores/id/:storeId/carts/*',
    storeProducts: '/stores/id/:storeId/products/*',
    storeBanners: '/stores/id/:storeId/banners/*',
    storePushNotifications: '/stores/id/:storeId/push-notifications/*',

    rates: '/rates',
    ostRates: '/rates/*',
    rate: '/rates/id/:rateId/*',
    rateSet: '/rates/id/:rateId/settings/*',

    products: '/products',
    product: '/products/id/:productId/*',
    productSet: '/products/id/:productId/settings/*',

    banners: '/banners',
    banner: '/banners/id/:bannerId/*',
    bannerSet: '/banners/id/:bannerId/settings/*',

    addAdvertising: '/advertisings/add-new-advertising',
    advertisings: '/advertisings',
    ostAdvertisings: '/advertisings/*',
    advertising: '/advertisings/id/:advertisingId/*',
    advertisingSet: '/advertisings/id/:advertisingId/settings/*'
}